<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>减免申请</span>
        <div>
          <el-radio-group v-model="query.state" size="small" @change="loadList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button label="1100">待审核</el-radio-button>
            <el-radio-button label="1200">已通过</el-radio-button>
            <el-radio-button label="1300">已驳回</el-radio-button>
            <el-radio-button label="1000">已撤回</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="filter-container">
        <el-input v-model="query.feeName" placeholder="费用项目名" clearable size="small"
          style="width:160px" @keyup.enter.native="loadList" />
        <el-button type="primary" size="small" @click="loadList">查询</el-button>
      </div>

      <el-table :data="list" border stripe size="small" v-loading="loading" style="width:100%">
        <el-table-column label="申请单号" prop="auditId" align="center" width="160" />
        <el-table-column label="房屋/车辆" align="center" width="120">
          <template #default="{row}">
            <span>{{ row.payerObjType === '3333' ? (row.roomNum || '-') : ('车位:' + (row.roomNum || row.payerObjId || '-')) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="费用项目" prop="feeName" align="center" min-width="100" />
        <el-table-column label="费用月份" align="center" width="210">
          <template #default="{row}">{{ formatMonth(row.feeStartTime || row.startTime) }}~{{ formatMonth(row.feeEndTime || row.endTime) }}</template>
        </el-table-column>
        <el-table-column label="申请减免" align="center" width="90">
          <template #default="{row}">
            <span style="color:#F56C6C;font-weight:bold">{{ parseFloat(row.deductionAmount||0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" width="145">
          <template #default="{row}">{{ formatTime(row.applyTime) }}</template>
        </el-table-column>
        <el-table-column label="减免原因" prop="message" align="center" min-width="160" show-overflow-tooltip />
        <el-table-column label="状态" align="center" width="80">
          <template #default="{row}">
            <el-tag :type="stateTagType(row.state)" size="mini">{{ stateText(row.state) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核人" prop="auditUserName" align="center" width="80" />
        <el-table-column label="审核时间" align="center" width="145">
          <template #default="{row}">{{ formatTime(row.auditTime) }}</template>
        </el-table-column>
        <el-table-column label="审核意见" prop="message" align="center" min-width="100" show-overflow-tooltip />
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template #default="{row}">
            <template v-if="row.state === '1100'">
              <el-button type="text" size="small" style="color:#F56C6C" @click="cancelApply(row)">撤回</el-button>
            </template>
            <span v-else style="color:#909399">-</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page.sync="query.page"
        :page-size="query.row"
        @current-change="loadList"
        style="margin-top:12px;text-align:right"
      />
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listFeeDeductionApply, cancelFeeDeductionApply } from '@/api/fee/feeDeductionApi'
import { getUserId } from '@/api/user/userApi'

export default {
  name: 'FeeDeductionMyApply',
  data() {
    return {
      communityId: '',
      userId: '',
      loading: false,
      list: [],
      total: 0,
      query: {
        state: '',
        feeName: '',
        page: 1,
        row: 15
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.userId = getUserId()
    this.loadList()
  },
  methods: {
    async loadList() {
      if (!this.userId) {
        this.list = []
        this.total = 0
        return
      }
      this.loading = true
      try {
        const res = await listFeeDeductionApply({
          communityId: this.communityId,
          state: this.query.state,
          applyUserId: this.userId,
          page: this.query.page,
          row: this.query.row
        })
        this.list = res.applys || []
        this.total = res.total || 0
      } catch (e) {
        console.error('加载减免申请失败', e)
      }
      this.loading = false
    },
    async cancelApply(row) {
      try {
        await this.$confirm(`确认撤回该减免申请？<br/>费用项目：${row.feeName}<br/>减免金额：${parseFloat(row.deductionAmount || 0).toFixed(2)} 元`,
          '撤回减免申请',
          { dangerouslyUseHTMLString: true, confirmButtonText: '确认撤回', cancelButtonText: '取消', type: 'warning' }
        )
      } catch (e) {
        return
      }
      try {
        await cancelFeeDeductionApply({
          communityId: this.communityId,
          auditId: row.auditId
        })
        this.$message.success('已撤回')
        this.loadList()
      } catch (e) {
        this.$message.error((e && (e.msg || e.message)) || '撤回失败')
      }
    },
    stateText(state) {
      return { '1100': '待审核', '1200': '已通过', '1300': '已驳回', '1000': '已撤回' }[state] || state
    },
    stateTagType(state) {
      return { '1100': 'warning', '1200': 'success', '1300': 'danger', '1000': 'info' }[state] || ''
    },
    formatTime(t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').substring(0, 19)
    },
    formatMonth(t) {
      if (!t) return '-'
      return String(t).replace('T', ' ').substring(0, 10)
    }
  }
}
</script>

<style scoped>
.app-container { padding: 20px; }
.filter-container { margin-bottom: 12px; }
.filter-container .el-input { margin-right: 8px; }
</style>
